import { useUser } from '@haohan/clw-store'
import { havePermission } from '@/utils/permission'
/**
 * {
 *  type: 'havaManager'
 * }
 * type:
 * havaManager  是否有后台管理权限
 * havePermission 是否拥有指定权限
 * isPersonal 当前项目是否是个人项目
 */
export default {
  mounted: (el, binding) => {
    const user = useUser()
    const type = binding.value.type || ''
    if (type === 'havaManager') {
      const companyPermission = user.current.permissions.filter((p) => {
        return [
          'CompanyManager',
          'CompanySecurity',
          'UserView',
          'UserManager',
          'RoleView',
          'RoleManager'
        ].find((e) => {
          return p.page === e
        })
      })
      // 找寻当前用户是否有管理中心相关得权限
      if (companyPermission.length === 0) {
        el.remove()
      }
    } else if (type === 'havePermission') {
      // 是否拥有指定权限
      const permission = binding.value.permission || ''
      const type = binding.value.permissionType || 'project'
      if (!havePermission(permission, type)) {
        el.remove()
      }
    } else if (type === 'isPersonal') {
      const userId = binding.value.userId || ''
      if (userId !== user.current.id) {
        el.remove()
      }
    }
  }
}
